(function () {
    $.fn.scrollto = function (options) {
        var settings = $.extend(
            {
                speed: 1000,
                offset: 0
            },
            options
        );

        this.on('click', '.page-navigation a[href^="#"]:not([href="#"])', function (event) {
            var targetId = $(this).attr('href');
            var $target = $(targetId);

            if ($target.length) {
                event.preventDefault();
                $('html, body').animate(
                    {
                        scrollTop: $target.offset().top + settings.offset
                    },
                    settings.speed
                );
            }
        });

        return this;
    };
})();

$(document).scrollto({
    speed: 800,
    offset: -200
});